module.exports = __webpack_public_path__ + "img/0010.811aa161.png";